import { createContext } from 'react';
import { ShowToastProps } from './types';

type NotificationContextType = {
  showToast(params: ShowToastProps): void;
};

export const NotificationsContext = createContext<NotificationContextType>(
  {} as NotificationContextType
);
